import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';
import { CompanyUser } from '../types/CompanyUser';

export const useGetCompanyUsers = (companyID: number) => {
    const { data, isLoading } = useQuery({
        queryKey: ['company-users', companyID],
        queryFn: async () => await apiClient.get('user/list') as CompanyUser[]
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
